module.exports = __webpack_public_path__ + "img/IMG_8926.28d4a59d.jpg";